import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import StepperPage from "./StepperPage";
import ContentSection from "./ContentSection";
import SwipeableViews from "react-swipeable-views";
import { connect } from "react-redux";
import "filepond/dist/filepond.min.css";
import { Trans } from "react-i18next";
import mime from "mime";
import {
  Card,
  CardHeader,
  CardContent,
  Tabs,
  Tab,
  TextField,
  Typography,
  IconButton,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
} from "@material-ui/core";
import {
  setTempId,
  setCustomFields,
  deleteCustomField,
  whatsUsingThem,
} from "../../redux/actions/customFieldsActions";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import { contentClient } from "../../AxiosClient";
import { FilePond, registerPlugin } from "react-filepond";
import { useSelector } from "react-redux";
import ReusableSectionsContentDialog from "./reusable-section/ReusableSectionsContentDialog";
import { Droppable, Draggable, DragDropContext } from "react-beautiful-dnd";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import KpsEditor from "../../components/editor/KpsEditor";
import { canDisplay } from "./MimeTypeHelper";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import CloseIcon from "@material-ui/icons/Close";
import UploadError from "../messages/UploadError";
import Alert from "@material-ui/lab/Alert";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import KpsTextField from "../../components/KpsTextField";
const useStyles = makeStyles((theme) => ({
  columns: { backgroundColor: theme.palette.grey[300] },
  section: {
    border: "1px dashed rgba(0, 0, 0, 0.4)",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    margin: "8px",
  },
}));
registerPlugin(FilePondPluginFileValidateSize);
registerPlugin(FilePondPluginFileValidateType);
const acceptedFileTypes = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-word.document.macroEnabled.12",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel.sheet.macroEnabled.12",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  "application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
  "application/msword",
  "application/vnd.ms-word",
  "application/msexcel",
  "application/x-excel",
  "application/x-msexcel",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "application/powerpoint",
  "application/x-powerpoint",
  "text/*",
  "audio/*",
  "video/*",
  "image/*",
  "application/javascript",
  "application/x-javascript",
  "application/ecmascript",
  "application/json",
  "application/xml",
  "application/x-python-code",
  "application/sql",
  "application/twb",
];
function ContentCreation(props) {
  const { t } = useTranslation();
  const [settings, setSettings] = useState([]);
  const [left, setLeft] = useState([]);
  const [middle, setMiddle] = useState([]);
  const [right, setRight] = useState([]);
  const [tempId, setTempId] = useState(1001);
  const [isDragging, setIsDragging] = useState(false);
  const [incomplete, setIncomplete] = useState([]);
  const [unsaved, setUnsaved] = useState([]);
  const [titleDirty, setTitleDirty] = useState(false);
  const [styleBorder, setStyleBorder] = useState({ margin: "8px" });
  const [tabsSelected, setTabsSelected] = useState(0);
  const [files, setFiles] = useState([]);
  const apiLocation = useSelector((state) => state.setting.apiLocation);
  const [editId, setEditId] = useState(null);
  const [editColumn, setEditColumn] = useState(null);
  const [deletedSectionDialog, setDeletedSectionDialog] = useState(false);
  const [deletedSectionAlert, setDeletedSectionAlert] = useState(false);
  const [cannotDisplay, setCannotDisplay] = useState(false);
  const [closeLeft, setCloseLeft] = useState(false);
  const [closeRight, setCloseRight] = useState(false);
  const [uploadError, setUploadError] = useState(false);

  useEffect(
    () => {
      if (props.template && props.template.layoutData) {
        setSettings(JSON.parse(props.template.layoutData));
      }
      if (
        props.template &&
        !props.edit &&
        props.template.layoutData &&
        !props.fileUpload
      ) {
        setSettings(JSON.parse(props.template.layoutData));
        ifTemplate();
      } else {
        if (props.content.layoutData) {
          setSettings(JSON.parse(props.content.layoutData));
        }
        ifRevision();
      }
    },
    [props.template]
  );

  useEffect(() => {
    if (!props.sections) return;
    let allSections = [];

    props.sections.map((section) => {
      allSections.push(section);
    });

    if (props.content.template) {
      allSections = allSections.concat(
        props.content.template.templateSections.filter(
          (t) =>
            !t.deleted &&
            allSections.map((s) => s.sectionID).indexOf(t.sectionID) < 0
        )
      );
    } else if (props.template && props.template.templateSections) {
      allSections = allSections.concat(
        props.template.templateSections.filter(
          (t) =>
            !t.deleted &&
            allSections.map((s) => s.sectionID).indexOf(t.sectionID) < 0
        )
      );
    }

    let right = [];
    let left = [];
    let middle = [];
    allSections.map((section) => {
      if (!section.deleted) {
        section.sectionColumn === "left"
          ? left.push(section)
          : section.sectionColumn === "right"
            ? right.push(section)
            : middle.push(section);
      }
    });

    setLeft(left.sort((a, b) => a.sortOrder - b.sortOrder));
    setRight(right.sort((a, b) => a.sortOrder - b.sortOrder));
    setMiddle(middle.sort((a, b) => a.sortOrder - b.sortOrder));

    if (left.length === 0) {
      setCloseLeft(true);
    }
    if (right.length === 0) {
      setCloseRight(true);
    }

    props.setSections(allSections);

    if (props.content && props.content.sectionsDTOs) {
      props.content.sectionsDTOs.map((section) => {
        section.deleted && setDeletedSectionAlert(true);
      });
    } else if (props.sections) {
      props.sections.map((section) => {
        section.deleted && setDeletedSectionAlert(true);
      });
    }
  }, []);

  useEffect(
    () => {
      if (!props.sections) return;
      let right = [];
      let left = [];
      let middle = [];
      props.sections.map((section) => {
        if (!section.deleted) {
          section.sectionColumn === "left"
            ? left.push(section)
            : section.sectionColumn === "right"
              ? right.push(section)
              : middle.push(section);
        }
      });

      setLeft(left.sort((a, b) => a.sortOrder - b.sortOrder));
      setRight(right.sort((a, b) => a.sortOrder - b.sortOrder));
      setMiddle(middle.sort((a, b) => a.sortOrder - b.sortOrder));
    },
    [props.sections]
  );

  useEffect(
    () => {
      if (settings.type === "borders") {
        setStyleBorder({
          borderColor: settings.border.colour,
          borderStyle: settings.border.style,
          borderWidth: settings.border.width,
          margin: "8px",
        });
      }
    },
    [settings]
  );

  useEffect(() => {
    props.whatsUsingThem("content");
    props.setDisabledHelperText(
      <Trans i18nKey="create_content_set_title_button_disabled">
        create_content_set_title_button_disabled
      </Trans>
    );
    // return function cleanup() {
    //   props.setCustomFields([]);
    //   props.whatsUsingThem("");
    // };
  }, []);

  useEffect(
    () => {
      if (props.file) {
        setFiles([
          {
            source: props.file.fileId,
            options: {
              type: "local",
              file: {
                name: props.file.fileName,
                size: props.file.size,
                type: props.file.contentType,
              },
            },
          },
        ]);
      }
    },
    [props.file]
  );

  useEffect(
    () => {
      if (!props.fileUpload) {
        if (props.content.title) {
          props.setNextDisabled(false);
        }
        return;
      }

      if (props.content.fileId) {
        if (props.content.title) {
          props.setNextDisabled(false);
        }
      } else {
        props.setNextDisabled(true);
      }
    },
    [props.content.fileId]
  );

  useEffect(
    () => {
      if (!props.content.title || props.content.title === "") {
        props.setNextDisabled(true);
        props.setDisabledHelperText(
          <Trans i18nKey="create_content_set_title_button_disabled">
            create_content_set_title_button_disabled
          </Trans>
        );
      } else {
        if (props.content.fileId || !props.fileUpload) {
          props.setNextDisabled(false);
        } else {
          props.setDisabledHelperText(
            <Trans i18nKey="create_content_add_file_button_disabled">
              create_content_add_file_button_disabled
            </Trans>
          );
        }
      }
    },
    [props.content.title]
  );

  const getTransKeyFromHttpStatus = (status, message) => {
    let translationKey = "unexpected_upload_error";
    switch (status) {
      case 409:
        translationKey = "virus_detected_in_file";
        break;
      case 413:
        translationKey = "file_too_big_to_process";
        break;
      case 418:
        // I'm a teapot.
        // Temporary method to handle internal 500 errors. See UV6-1207
        // Error type is propagated as a translation key
        // First characters are the Http status it prepresents
        // e.g. 500_AV_NOT_DEFINED
        if (!!message && message.length > 0) {
          translationKey = message;
        }
    }
    return translationKey;
  };

  const ifRevision = () => {
    contentClient
      .get(`/revision/${props.content.revisionId}/customfield/`)
      .then((res) => {
        let currentCustomFields = res.data;
        let tempId = props.tempId ? props.tempId : 1;
        // for (let i = 0; i < currentCustomFields.length; i++) {
        //   //currentCustomFields[i].tempId = tempId;
        //   currentCustomFields[i].template = false;
        //   if(currentCustomFields[i].tempId >tempId) tempId=currentCustomFields[i].tempId;
        //   // tempId++;
        // }
        props.setTempId(tempId);
        props.setCustomFields(currentCustomFields);
        if (props.customFieldsChange) {
          props.customFieldsChange(currentCustomFields);
        }
      });
  };

  const ifTemplate = () => {
    contentClient
      .get(`/template/${props.template.id}/customfield/`)
      .then((res) => {
        let currentCustomFields = res.data;
        // let tempId = 0;
        // for (let i = 0; i < currentCustomFields.length; i++) {
        //   currentCustomFields[i].template = true;
        //   if (tempId < currentCustomFields[i].tempId) {
        //     tempId = currentCustomFields[i].tempId;
        //   }
        // }
        // props.setTempId(tempId);
        props.setCustomFields(currentCustomFields);
        if (props.customFieldsChange) {
          props.customFieldsChange(currentCustomFields);
        }
      });
  };
  const sortIncomplete = (incompleteInc, section) => {
    let newIncomplete = [];
    let found = false;
    incomplete.map((incompleteSection) => {
      if (section.sectionID === incompleteSection.sectionID) {
        found = true;
      } else if (!incompleteInc) {
        newIncomplete.push(incompleteSection);
      }
    });
    if (incompleteInc && !found) {
      newIncomplete.push(section);
    }
    props.setIncomplete(newIncomplete);
  };

  const sortUnsaved = (isUnsaved, candidateId) => {
    let newUnsaved = [];
    let found = false;
    unsaved.map((incumbentId) => {
      if (candidateId === incumbentId) {
        found = true;
      } else if (!isUnsaved) {
        newUnsaved.push(incumbentId);
      }
    });
    if (isUnsaved && !found) {
      newUnsaved.push(candidateId);
    }
    props.setUnsaved(newUnsaved);
  };

  const remove = (section) => {
    //remove CF here
    if(section.reusableSectionId && section.customFieldsRVOs){
      let clone = [];
      props.currentCustomFields.forEach(cf=>{
        let result = section.customFieldsRVOs.find((rvo) => rvo.id == cf.id);
        if(!result){
          clone.push(cf);
        }
      });
      props.setCustomFields(clone);
    }
    let tempSections = [...props.sections];
    let index;
    tempSections.map((mapSection, idx) => {
      if (section.tempId === mapSection.tempId) {
        index = idx;
      }
    });
    tempSections.splice(index, 1);
    props.setSections(tempSections);
  };

  const onSectionDragEnd = (one, leftCurrent, rightCurrent, middleCurrent) => {
    setIsDragging(false);
    let left = [...leftCurrent];
    let right = [...rightCurrent];
    let middle = [...middleCurrent];
    let section;
    if (one.source.droppableId === "droppableMiddle") {
      section = { ...middle[one.source.index] };
      middle.splice(one.source.index, 1);
    } else if (one.source.droppableId === "droppableLeft") {
      section = { ...left[one.source.index] };
      left.splice(one.source.index, 1);
    } else {
      section = { ...right[one.source.index] };
      right.splice(one.source.index, 1);
    }

    if (one.destination.droppableId === "droppableMiddle") {
      section.sectionColumn = "middle";
      middle.splice(one.destination.index, 0, section);
    } else if (one.destination.droppableId === "droppableLeft") {
      section.sectionColumn = "left";
      left.splice(one.destination.index, 0, section);
    } else {
      section.sectionColumn = "right";
      right.splice(one.destination.index, 0, section);
    }
    left = left.map((section, index) => ({ ...section, sortOrder: index }));
    right = right.map((section, index) => ({ ...section, sortOrder: index }));
    middle = middle.map((section, index) => ({ ...section, sortOrder: index }));
    setLeft(left);
    setRight(right);
    setMiddle(middle);
    props.setSections([...left, ...middle, ...right]);
  };

  const onAddSection = (section) => {
    //Add CF here
    props.setCustomFields([ ...props.currentCustomFields, ...section.customFieldsRVOs ]);
    let currentLeft = [...left];
    let currentRight = [...right];
    let currentMiddle = [...middle];
    if (section.sectionColumn === "right") {
      currentRight = [...currentRight, section];
      setRight(currentRight);
    }
    if (section.sectionColumn === "left") {
      currentLeft = [...currentLeft, section];
      setLeft(currentLeft);
    }
    if (section.sectionColumn === "middle") {
      currentMiddle = [...currentMiddle, section];
      setMiddle(currentMiddle);
    }
    props.setSections([...currentLeft, ...currentMiddle, ...currentRight]);
  };
  const setTabsSelectedFunction = (e, val) => {
    setTabsSelected(parseInt(e.currentTarget.attributes.idx.value));
  };

  const openDeletedSectionDialog = () => {
    setDeletedSectionDialog(!deletedSectionDialog);
  };

  const classes = useStyles();
  return (
    <div
      style={{
        overflow: "auto",
        height: "100%",
        alignItems: "stretch",
        width: "100%",
      }}
    >
      <div>
        <Typography variant="h5">
          {props.edit ? (
            <Trans i18nKey="edit_content_creation_header">
              edit_content_creation_header
            </Trans>
          ) : (
            <Trans i18nKey="create_content_creation_header">
              create_content_creation_header
            </Trans>
          )}
        </Typography>
        <Typography variant="body2" gutterBottom>
          {props.edit ? (
            <Trans i18nKey="edit_content_creation_subheader">
              edit_content_creation_subheader
            </Trans>
          ) : (
            <Trans i18nKey="create_content_creation_subheader">
              create_content_creation_subheader
            </Trans>
          )}
        </Typography>
      </div>
      <CardHeader
        style={{ paddingTop: 0 }}
        title={
          <div>
            {/* <TextField
              inputProps={{ style: { fontSize: 25 } }}
              error={
                titleDirty &&
                (!props.content.title || props.content.title === "")
              }
              label="Title"
              aria-label="Content title text input"
              autoFocus
              fullWidth
              required
              value={props.content.title}
              id="content-title"
              helperText={
                titleDirty &&
                (!props.content.title || props.content.title === "") ? (
                  <Trans i18nKey="create_content_title_required">
                    create_content_title_required
                  </Trans>
                ) : (
                  ""
                )
              }
              onBlur={() => setTitleDirty(true)}
              onChange={(e) => {
                setTitleDirty(true);
                props.updateContent({
                  ...props.content,
                  title: e.target.value,
                });
              }}
              margin="none"
            /> */}
            <KpsTextField
              inputProps={{ style: { fontSize: 25 } }}
              error={
                titleDirty &&
                (!props.content.title || props.content.title === "")
              }
              label="Title"
              aria-label="Content title text input"
              autoFocus
              fullWidth
              required
              value={props.content.title}
              id="content-title"
              helperText={
                titleDirty &&
                (!props.content.title || props.content.title === "") ? (
                  <Trans i18nKey="create_content_title_required">
                    create_content_title_required
                  </Trans>
                ) : (
                  ""
                )
              }
              onBlur={() => setTitleDirty(true)}
              onChange={(e) => {
                setTitleDirty(true);
                props.updateContent({
                  ...props.content,
                  title: e.target.value,
                });
              }}
              margin="none"
            />
          </div>
        }
      />
      <CardContent style={{ flex: 1, display: "flex" }}>
        <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
          {props.fileUpload ? (
            <div style={{ width: "100%" }}>
              {cannotDisplay && (
                <Alert
                  severity="warning"
                  style={{
                    width: "fit-content",
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginBottom: 15,
                  }}
                >
                  <Trans i18nKey="cannot_display_file_type_alert" />
                </Alert>
              )}
              <FilePond
                files={files}
                allowMultiple={false}
                allowRevert={false}
                acceptedFileTypes={acceptedFileTypes}
                allowSyncAcceptAttribute={false}
                labelFileTypeNotAllowed="Invalid file type"
                fileValidateTypeLabelExpectedTypes="This file type is not allowed"
                maxFileSize="2000MB"
                labelFileProcessingError={(err) => {
                  return err && err.body ? err.body : "File upload failed";
                }}
                fileValidateTypeDetectType={(source, type) =>
                  new Promise((res, rej) => {
                    if (!type) {
                      res("text/plain");
                    } else {
                      res(type);
                    }
                  })
                }
                server={{
                  process: (
                    fieldName,
                    file,
                    metadata,
                    load,
                    error,
                    progress,
                    abort,
                    transfer,
                    options
                  ) => {
                    // the browser can only detect a few content types, but try to
                    // catch it early if possible
                    if (!canDisplay(file.type ? file.type : "text/plain")) {
                      setCannotDisplay(true);
                    } else {
                      setCannotDisplay(false);
                    }
                    let timeout = null;
                    const formData = new FormData();
                    formData.append("file", file, file.name);
                    const request = new XMLHttpRequest();
                    request.withCredentials = true
                    request.open(
                      "POST",
                      `https://${apiLocation}/contentservice/knowledgeitem/file/`
                    );
                    request.upload.onprogress = (e) => {
                      progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function() {
                      let payload = JSON.parse(request.responseText);
                      if (request.status >= 200 && request.status < 300) {
                        // we get a much more accurate content type back from Tika so check again
                        if (
                          payload.contentType &&
                          !canDisplay(payload.contentType)
                        ) {
                          setCannotDisplay(true);
                        }
                        load(payload.uuid);
                      } else {
                        let key = getTransKeyFromHttpStatus(
                          request.status,
                          payload.message
                        );
                        error(t(key));
                        setUploadError(key);
                      }
                    };
                    request.send(formData);
                    return {
                      abort: () => {
                        request.abort();
                        setCannotDisplay(false);
                        abort();
                      },
                    };
                  },
                }}
                onprocessfile={(_err, file) => {
                  props.updateContent({
                    ...props.content,
                    fileId: file.serverId,
                    originalFilename: file.filename,
                  });
                }}
                onupdatefiles={(fileItems) => {
                  setFiles(fileItems.map((fileItem) => fileItem.file));
                }}
              />
              <Typography>
                <Trans i18nKey="ki_file_description" />
              </Typography>
              <ul>
                <Typography component="li">
                  Office documents (viewable as both HTML and PDF)
                </Typography>
                <Typography component="li">PDF files</Typography>
                <Typography component="li">HTML files</Typography>
                <Typography component="li">Plain text files</Typography>
                <Typography component="li">
                  GIF, JPEG, PNG, SVG or BMP images
                </Typography>
                <Typography component="li">OGG, MP4 and WEBM videos</Typography>
                <Typography component="li">
                  MPEG, WAV, MP3/MP4, OGG, and WEBM audio files
                </Typography>
              </ul>
            </div>
          ) : (
            <DragDropContext
              onDragEnd={(event) =>
                onSectionDragEnd(event, left, right, middle)
              }
              onDragStart={() => setIsDragging(true)}
            >
              <div style={{ height: "100%", width: "100%", display: "flex" }}>
                <Droppable droppableId="droppableLeft" direction="vertical">
                  {(provided, snapshot) => (
                    <div
                      style={{
                        flex:
                          (!editId || (editId && editColumn === "left")) &&
                          !closeLeft &&
                          1,
                        width:
                          (editId && editColumn != "left") || (closeLeft && 0),
                        transition: "all .5s",
                      }}
                      className={isDragging ? classes.columns : classes.section}
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {!closeLeft && (
                        <div style={{ display: "flex" }}>
                          <div style={{ width: "100%" }} />
                          <IconButton
                            onClick={() => {
                              setCloseLeft(!closeLeft);
                            }}
                          >
                            <ChevronLeftIcon />
                          </IconButton>
                        </div>
                      )}
                      {left.map((section, idx) => {
                        return (
                          <Draggable
                            isDragDisabled={!section.canMove}
                            draggableId={
                              section.id ? section.id : section.tempId
                            }
                            index={idx}
                            key={
                              section.sectionID
                                ? section.sectionID
                                : section.tempId
                            }
                          >
                            {(dragProvided, dragSnapshot) => (
                              <div
                                ref={dragProvided.innerRef}
                                {...dragProvided.draggableProps}
                                key={
                                  section.sectionID
                                    ? section.sectionID
                                    : section.tempId
                                }
                              >
                                <Card id="card" style={{ margin: "8px" }}>
                                  <ContentSection
                                    editId={editId}
                                    remove={remove}
                                    dragHandleProps={
                                      dragProvided.dragHandleProps
                                    }
                                    {...props}
                                    section={section}
                                    setEditId={(id, column) => {
                                      setEditId(id);
                                      setEditColumn(column);
                                    }}
                                    setIncomplete={sortIncomplete}
                                    setUnsaved={sortUnsaved}
                                  />
                                </Card>
                              </div>
                            )}
                          </Draggable>
                        );
                        // }
                      })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
                {closeLeft && (
                  <div>
                    <IconButton
                      onClick={() => {
                        setCloseLeft(!closeLeft);
                      }}
                    >
                      <ChevronRightIcon />
                    </IconButton>
                  </div>
                )}
                <Droppable droppableId="droppableMiddle" direction="vertical">
                  {(provided, snapshot) => (
                    <div
                      style={{
                        flex:
                          (!editId || (editId && editColumn === "middle")) && 3,
                        margin: "8px",
                        width: editId && editColumn != "middle" && 0,
                        transition: "all .5s",
                      }}
                      className={isDragging ? classes.columns : classes.section}
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {settings.type === "cards" &&
                        middle.map((section, idx) => {
                          return (
                            <Draggable
                              draggableId={
                                section.id ? section.id : section.tempId
                              }
                              index={idx}
                              key={
                                section.sectionID
                                  ? section.sectionID
                                  : section.tempId
                              }
                            >
                              {(dragProvided, dragSnapshot) => (
                                <div
                                  ref={dragProvided.innerRef}
                                  {...dragProvided.draggableProps}
                                >
                                  <Card id="card" style={{ margin: "8px" }}>
                                    <ContentSection
                                      editId={editId}
                                      setEditId={(id, column) => {
                                        setEditId(id);
                                        setEditColumn(column);
                                      }}
                                      dragHandleProps={
                                        dragProvided.dragHandleProps
                                      }
                                      remove={remove}
                                      {...props}
                                      section={section}
                                      setIncomplete={sortIncomplete}
                                      setUnsaved={sortUnsaved}
                                    />
                                  </Card>
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                      {settings.type === "tabs" && (
                        <>
                          <Tabs
                            value={tabsSelected}
                            onChange={setTabsSelectedFunction}
                          >
                            {middle.map((section, idx) => (
                              <Draggable
                                isDragDisabled={!section.canMove}
                                draggableId={
                                  section.id ? section.id : section.tempId
                                }
                                index={idx}
                                key={
                                  section.sectionID
                                    ? section.sectionID
                                    : section.tempId
                                }
                              >
                                {(dragProvided, dragSnapshot) => (
                                  <div
                                    ref={dragProvided.innerRef}
                                    // innerRef={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    {...dragProvided.dragHandleProps}
                                    idx={idx}
                                  >
                                    <Tab
                                      onClick={setTabsSelectedFunction}
                                      key={idx}
                                      idx={idx}
                                      label={section.name}
                                    />
                                  </div>
                                )}
                              </Draggable>
                            ))}
                          </Tabs>
                          <SwipeableViews
                            index={tabsSelected}
                            id="templatePages"
                          >
                            {middle.map((section, idx) => {
                              return (
                                <Draggable
                                  isDragDisabled={!section.canMove}
                                  draggableId={
                                    section.id ? section.id : section.tempId
                                  }
                                  index={idx}
                                  key={
                                    section.sectionID
                                      ? section.sectionID
                                      : section.tempId
                                  }
                                >
                                  {(dragProvided, dragSnapshot) => (
                                    <div
                                      idx={idx}
                                      key={idx}
                                      ref={dragProvided.innerRef}
                                      innerRef={dragProvided.innerRef}
                                      {...dragProvided.draggableProps}
                                    >
                                      <ContentSection
                                        editId={editId}
                                        remove={remove}
                                        dragHandleProps={
                                          dragProvided.dragHandleProps
                                        }
                                        {...props}
                                        setEditId={(id, column) => {
                                          setEditId(id);
                                          setEditColumn(column);
                                        }}
                                        section={section}
                                        setIncomplete={sortIncomplete}
                                        setUnsaved={sortUnsaved}
                                      />
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })}
                          </SwipeableViews>
                        </>
                      )}
                      {settings.type === "borders" &&
                        middle.map((section, idx) => {
                          return (
                            <Draggable
                              isDragDisabled={!section.canMove}
                              draggableId={
                                section.id ? section.id : section.tempId
                              }
                              index={idx}
                              key={
                                section.sectionID
                                  ? section.sectionID
                                  : section.tempId
                              }
                            >
                              {(dragProvided, dragSnapshot) => (
                                <div
                                  // style={styleBorder}
                                  index={idx}
                                  key={idx}
                                  idx={idx}
                                  ref={dragProvided.innerRef}
                                  innerRef={dragProvided.innerRef}
                                  {...dragProvided.draggableProps}
                                >
                                  <div style={styleBorder}>
                                    <ContentSection
                                      editId={editId}
                                      setEditId={(id, column) => {
                                        setEditId(id);
                                        setEditColumn(column);
                                      }}
                                      remove={remove}
                                      dragHandleProps={
                                        dragProvided.dragHandleProps
                                      }
                                      {...props}
                                      section={section}
                                      setIncomplete={sortIncomplete}
                                      setUnsaved={sortUnsaved}
                                    />
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
                {closeRight && (
                  <div>
                    <IconButton
                      onClick={() => {
                        setCloseRight(!closeRight);
                      }}
                    >
                      <ChevronLeftIcon />
                    </IconButton>
                  </div>
                )}
                <Droppable droppableId="droppableRight" direction="vertical">
                  {(provided, snapshot) => (
                    <div
                      style={{
                        flex:
                          (!editId || (editId && editColumn === "right")) &&
                          !closeRight &&
                          1,
                        width:
                          (editId && editColumn != "right") ||
                          (closeRight && 0),
                        transition: "all .5s",
                      }}
                      className={isDragging ? classes.columns : classes.section}
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {!closeRight && (
                        <div style={{ display: "flex" }}>
                          <IconButton
                            onClick={() => {
                              setCloseRight(!closeRight);
                            }}
                          >
                            <ChevronRightIcon />
                          </IconButton>
                          <div style={{ width: "100%" }} />
                        </div>
                      )}
                      {right.map((section, idx) => {
                        return (
                          <Draggable
                            isDragDisabled={!section.canMove}
                            draggableId={
                              section.id ? section.id : section.tempId
                            }
                            index={idx}
                            key={
                              section.sectionID
                                ? section.sectionID
                                : section.tempId
                            }
                          >
                            {(dragProvided, dragSnapshot) => (
                              <div
                                ref={dragProvided.innerRef}
                                {...dragProvided.draggableProps}
                              >
                                <Card id="card" style={{ margin: "8px" }}>
                                  <ContentSection
                                    editId={editId}
                                    setEditId={(id, column) => {
                                      setEditId(id);
                                      setEditColumn(column);
                                    }}
                                    dragHandleProps={
                                      dragProvided.dragHandleProps
                                    }
                                    remove={remove}
                                    {...props}
                                    section={section}
                                    setIncomplete={sortIncomplete}
                                    setUnsaved={sortUnsaved}
                                  />
                                </Card>
                              </div>
                            )}
                          </Draggable>
                        );
                        // }
                      })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </DragDropContext>
          )}
        </div>
      </CardContent>
      <Dialog fullWidth open={deletedSectionDialog}>
        <DialogTitle>
          <Trans i18nKey="deleted_section" />
        </DialogTitle>
        <DialogContent>
          {props.content.sectionsDTOs
            ? props.content.sectionsDTOs.map((section) => {
                if (section.deleted) {
                  return (
                    <KpsEditor
                      focusOnMount
                      initialContent={section.defaultText}
                    />
                  );
                }
              })
            : props.sections &&
              props.sections.map((section) => {
                if (section.deleted) {
                  return (
                    <KpsEditor
                      focusOnMount
                      initialContent={section.defaultText}
                    />
                  );
                }
              })}
        </DialogContent>
        <DialogActions>
          <Button onClick={openDeletedSectionDialog}>
            <Trans i18nKey="global_close" />
          </Button>
        </DialogActions>
      </Dialog>
      <ReusableSectionsContentDialog
        open={props.openAddReusableSection}
        onClose={props.onCloseAddReusableSection}
        {...props}
        tempId={tempId}
        setTempId={setTempId}
        onAddSection={onAddSection}
      />
      {deletedSectionAlert && (
        <Alert
          severity="warning"
          style={{
            width: "fit-content",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          elevation={3}
          action={
            <IconButton onClick={openDeletedSectionDialog}>
              <AddIcon />
            </IconButton>
          }
        >
          <Trans i18nKey="deleted_section_warning_message" />
        </Alert>
      )}
      <UploadError
        uploadError={uploadError}
        setUploadError={() => setUploadError(null)}
      />
    </div>
  );
}
const mapStateToProps = (state) => ({
  currentCustomFields: state.customFields.currentCustomFields,
});
const mapDispatchToProps = {
  setTempId,
  setCustomFields,
  deleteCustomField,
  whatsUsingThem,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StepperPage(ContentCreation));
